import excel from "@/libs/excel";
const exportExcel = (excelData, arr, filename, _this) => {
  if (excelData.length) {
    const params = {
      title: arr.map(item => {
        return item.title;
      }),
      key: arr.map(item => {
        return item.key;
      }),
      data: excelData,
      autoWidth: true,
      filename: filename
    };
    excel.export_array_to_excel(params);
    // _this.selectAll = [];
  } else {
    _this.$Message["error"]({
      background: true,
      content: "Export data cannot be empty !",
      duration: 5
    });
  }
};
export default { exportExcel };
